<template>
  <div id="">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="" v-html="$store.state.app.terms_business">

          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
</style>
